
import { useEffect } from "react";
import { createContext, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { enqueueSnackbar } from "notistack";
import { fetchDataFromApi, patchDataApi } from "./api";

export const Context = createContext();

const AppContext = ({ children }) => {

    const { user } = useSelector((state) => state.user)
    let userData = JSON.parse(localStorage.getItem("user")) || {};
    let userID = userData?.user?._id

    const [categories, setCategories] = useState();
    const [products, setProducts] = useState();
    const [banner, setBanner] = useState();
    const [banner2, setBanner2] = useState();
    const [showCart, setShowCart] = useState(false);
    const [showWishlist, setShowWishlist] = useState(false);
    const [cartItems, setCartItems] = useState([]);
    const [page, setPage] = useState(0)
    const [total, setTotal] = useState(0)
    const [orderRoutes, setorderRoutes] = useState(true)

    const [orderDetailItem, setOrderDetailItem] = useState("");

    const [cartLoading, setcartLoading] = useState(false)
    const [ordersLoading, setOrdersLoading] = useState(false)
    const [userOrders, setUserOrders] = useState([]);
    const [newOrder, setNewOrder] = useState({
        userID,
        total: "",
        subtotal: "",
        delivery_charges: "",
        coupen_discount: "",
        coupen_applied: "",
        delivery_status: "not_initialized",
        payment_mode: "",
        payment_status: "PAYMENT_PENDING",
        products: [],
        shipping_address: {},
    })


    const [formData, setFormData] = useState({
        email: '',
        name: '',
        mobile: '',
        pincode: '',
        locality: '',
        address: "",
        city: "",
        state: '',
        landmark: '',
        addressType: "",
    });

    const navigate = useNavigate()
    const [auth, setAuth] = useState()
    const [homeproduct, setHomeproduct] = useState([
        { heading: "shubham" },
        { heading: "shubham" },
        { heading: "shubham" },
    ]);




    useEffect(() => {
        const storedOrderRoutes = localStorage.getItem('json');
        if (storedOrderRoutes !== null) {
            setorderRoutes(JSON.parse(storedOrderRoutes));
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('json', JSON.stringify(orderRoutes));
    }, [orderRoutes]);
    useEffect(() => {
        localStorage.setItem('address', JSON.stringify(formData));
    }, [formData]);

    let getData = () => {
        setcartLoading(true)
        if (!userID) return setcartLoading(false)
        fetchDataFromApi("/cart/get-cart/" + userID)
            .then((res) => setCartItems(res?.cart?.products))
            .catch((error) => console.log(error))
            .finally(() => setcartLoading(false))
        setOrdersLoading(true)
        fetchDataFromApi("/orders/" + userID)
            .then((res) => setUserOrders(res?.data))
            .catch((error) => console.log(error))
            .finally(() => setOrdersLoading(false))
    }

    useEffect(() => {
        getData()
    }, []);

    let cartCount = 0;
    cartItems?.map((item) => (cartCount += item.quantity));

    let cartSubTotal = 0;
    cartItems?.map(
        (item) =>
            (cartSubTotal += item.price * item.quantity)
    );

    const UpdateCartByUserId = (userId, cartitems) => {
        patchDataApi("/cart/update-cart/" + userId, {}, { cart: cartitems })
            .then((res) => {
                setCartItems(res?.newCart?.products)
            }).catch((err) => {
                console.log(err)
            }).finally(() => setcartLoading(false))
    }

    const handleAddToCart = (product, quantity) => {
        setcartLoading(true)
        let items = [...cartItems];
        let productId = product.productID

        let index = items.findIndex((p) => {
            if (p.productType == "Single") {
                return p.productID === productId
            } else if (p.productType === "WithColor") {
                return (p.productID === productId && p.color === product.color)
            } else if (p.productType === "WithSize") {
                return (p.productID === productId && p.size === product.size)
            } else {
                return (p.productID === productId && p.size === product.size && p.color === product.color)
            }
        });
        if (index !== -1) {
            items[index].quantity += quantity;
            setShowCart(true)
            setCartItems(items);
            enqueueSnackbar("Added to Cart Successfully", { variant: "success" })
        } else {
            items = [...items, product];
            setShowCart(true)
            setCartItems(items);
            enqueueSnackbar("Added to Cart Successfully", { variant: "success" })
        }
        UpdateCartByUserId(userID, items)
    };
    const handleRemoveFromCart = (product) => {
        setcartLoading(true)
        let items = [...cartItems];
        items = items?.filter((p) => p._id !== product?._id);
        UpdateCartByUserId(userID, items)
    };
    const handleCartProductQuantity = (type, product) => {
        setcartLoading(true)
        let items = [...cartItems];
        let index = items?.findIndex((p) => p._id === product?._id);
        if (type === "inc") {
            items[index].quantity += 1;
        } else if (type === "dec") {
            if (items[index].quantity === 1) return;
            items[index].quantity -= 1;
        }
        UpdateCartByUserId(userID, items)
    };

    const handleIncPage = () => {
        if (page === 1) {
            if (user.success === false)
                navigate('/login')
        }
        if (page === 2) {
            return 0
        } {
            setPage(page + 1)
        }

    }
    const handleDecPage = () => {
        if (page === 0) {
            return 0
        } else {

            setPage(page - 1)
        }

    }

    return (
        <Context.Provider
            value={{
                products, setProducts, banner, setBanner, banner2, setBanner2,
                homeproduct, setHomeproduct, categories, setCategories, cartItems,
                setCartItems, handleAddToCart, handleRemoveFromCart, showCart, setShowCart,
                showWishlist, setShowWishlist, handleCartProductQuantity, page, setPage,
                total, setTotal, auth, setAuth, handleIncPage, handleDecPage,
                orderRoutes, setorderRoutes, formData, setFormData, cartSubTotal, cartCount,
                cartLoading, newOrder, setNewOrder, userOrders, ordersLoading, setOrderDetailItem, orderDetailItem
            }}
        >
            {children}
        </Context.Provider>
    );
};

export default AppContext;


